const STACK = Object.freeze({
  PROD: "PROD",
  STAGE: "STAGE",
  DEV: "DEV",
});

const stack = process.env.FEATURE_FLAGS_STACK;

const flags = {
  CLASS_PROGRESS_REPORT: {
    [STACK.PROD]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  MOCK_ERSS_SKILLS_DIAGNOSTIC: {
    [STACK.PROD]: false,
    [STACK.STAGE]: false,
    [STACK.DEV]: false,
  },
  DYSLEXIA_PARENT_LETTERS: {
    [STACK.PROD]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  UTTERANCE_LOGS: {
    [STACK.PROD]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
  UNIVERSAL_GENERATIVE_VOICE: {
    [STACK.PROD]: true,
    [STACK.STAGE]: true,
    [STACK.DEV]: true,
  },
};

// Generate FEATURE_FLAGS based on the current stack
export const FEATURE_FLAGS = Object.fromEntries(
  Object.entries(flags).map(([key, value]) => [key, value[stack]])
);
